import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import OrganizationWaitingTimePerService from "../../../components/organization/reports/daily/OrganizationWaitingTimePerService";
import {
  WAITING_TIME_PER_SERVICE_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const DailyOrganizationWaitingTimePerService = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={WAITING_TIME_PER_SERVICE_COLUMN_DEFINITIONS}
    descriptionKey="WaitingTimePerService"
    title={`${reportIndex}. Waiting Time Per Service`}
  >
    {({ data, renderConfig }) => (
      <OrganizationWaitingTimePerService reportIndex={reportIndex} data={data} renderConfig={renderConfig} />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationWaitingTimePerService;
